import { render, staticRenderFns } from "./AudioNotification.vue?vue&type=template&id=205a63f4&"
import script from "./AudioNotification.vue?vue&type=script&lang=ts&"
export * from "./AudioNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports